import axios from "axios";
import { API_URL } from "../services/Const";

const instance = axios.create({
  baseURL: API_URL,
  // timeout: 10000,
  // headers: { 'api-key': 'eyJz-CI6Ikp-4pWY-lhdCI6' }
});

export default instance;